import moment from 'moment';

import RestService from '../services/rest';

// GET
async function getInboundCheckInvoices(startDate, endDate) {
  const sDate = moment(startDate).format();
  const eDate = moment(endDate).format();
  return RestService.getAuthenticated(
    `inboundCheck/queryInvoices?startDate=${sDate}&endDate=${eDate}`,
  );
}

async function getInboundCheckInvoice(invoiceId) {
  return RestService.getAuthenticated(`inboundCheck/invoice?inboundOrderId=${invoiceId}`);
}

async function getInboundCheckInvoiceByNumber(orderNumber) {
  return RestService.getAuthenticated(`inboundCheck/invoiceByNumber?orderNumber=${orderNumber}`);
}

async function getInboundCheckProductByEan(ean, invoiceId) {
  return RestService.getAuthenticated(`inboundCheck/productByEan?ean=${ean}&inboundOrderId=${invoiceId}`);
}

async function getInboundCheckProductByCode(productCode, invoiceId) {
  return RestService.getAuthenticated(
    `inboundCheck/productByCode?productCode=${productCode}&inboundOrderId=${invoiceId}`,
  );
}

async function getEmptyStorageAddresses(branchCode, productCode, filterStatus = false) {
  return RestService.getAuthenticated(
    `storageAddresses/list/empty?branchCode=${branchCode}&productCode=${productCode}&filterStatus=${filterStatus}`,
  );
}

async function getInboundOrderProductAddresses(
  branchCode,
  productCode,
  filterStatus,
  quantity,
  lotNumber,
  expirationDate,
  orderType,
) {
  return RestService.getAuthenticated('inboundCheck/getInboundOrderProductAddresses', {
    branchCode,
    productCode,
    filterStatus,
    quantity,
    ...(lotNumber ? { lotNumber } : {}),
    ...(expirationDate ? { expirationDate } : {}),
    orderType,
  });
}

function trimLots(lots) {
  if (!lots || !lots.length) return lots;
  return lots.map((lot) => ({
    ...lot,
    lotNumber: lot.lotNumber && typeof lot.lotNumber === 'string'
      ? lot.lotNumber.trim()
      : lot.lotNumber,
  }));
}

// PUT
async function putConfirmCount(
  inboundOrderProductId,
  count,
  damageCount,
  baptism,
  invoiceId,
  lots,
  netWeight,
  volume,
  grossWeight,
  width,
  length,
  height,
  divergenceNote,
  suggestedAddress,
  partialCheck,
  serialGroupId,
  stage,
  crossdockingId,
) {
  return RestService.putAuthenticated('inboundCheck/confirmCount', {
    inboundOrderProductId,
    count,
    damageCount,
    baptism,
    invoiceId,
    lots: trimLots(lots),
    netWeight,
    volume,
    grossWeight,
    width,
    length,
    height,
    divergenceNote,
    suggestedAddress,
    partialCheck,
    serialGroupId,
    stage,
    crossdockingId,
  });
}

async function getLackAddress(branchCode) {
  return RestService.getAuthenticated(`inboundCheck/lackAddress?branchCode=${branchCode}`);
}

export default {
  getInboundCheckInvoices,
  getInboundCheckInvoice,
  getInboundCheckProductByEan,
  getInboundCheckProductByCode,
  getInboundCheckInvoiceByNumber,
  getEmptyStorageAddresses,
  putConfirmCount,
  getInboundOrderProductAddresses,
  getLackAddress,
};
